<template>
  <div class="top-contianer">
    <!-- <br /> -->
    <!-- <div class="main_header"> -->
    <!-- <div @click="toggleLight()" id="vdrax-background" class="vdrax-background">
        <h1
          class="header-img-text"
        >Vortex Services spreaded into the Commercial field through ROV rent</h1>
    </div>-->
    <div class="video-container">
      <video
        autoplay
        muted
        loop
        class="commercial-video"
        poster="../../public/vid/posters/commercial_vdrax.png"
      >
        <source src="../../public/vid/vdrax_commercial.mp4" type="video/mp4" />
      </video>

      <div class="overlay">
        <b-container class="centered categs-container">
          <b-row>
            <b-col @click="scrollToDiv('rovs_cards')" class="categs">
              <div>
                <a href="#rovs_cards">Products</a>
              </div>
            </b-col>
            <b-col @click="scrollToDiv('services_pre_div')" class="categs">
              <div>
                <a href="#services_pre_div">Services</a>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <div @click="scrollToDiv('rovs_cards')" class="bounce">
                <a href="#rovs_cards">
                  <span class="down-arrow">&raquo;</span>
                </a>
              </div>
            </b-col>
            <b-col cols="6">
              <div @click="scrollToDiv('services_pre_div')" class="bounce">
                <a href="#services_pre_div">
                  <span class="down-arrow">&raquo;</span>
                </a>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <GearsSep />

    <div style="height: 100px; width 100%;" id="rovs_cards"></div>
    <div class="prod-serv-container eliptical-gray">
      <br />
      <h2 class="back-text">Our Specialization</h2>
      <h3 style="color: #00264a; font-weight: bold;">Our Products</h3>
      <div class="breaker"></div>

      <br />
      <br />
      <br />
      <b-container class="rovs_cards">
        <b-row>
          <b-col sm="4" v-for="rov in commercialRovs" :key="rov.id">
            <div>
              <b-card no-body tag="article" class="mb-2 rov-card">
                <!-- <b-carousel
                  id="carousel-1"
                  v-model="slide"
                  :interval="2000"
                  controls
                  indicators
                  background="#ababab"
                  img-width="1024"
                  img-height="480"
                  style="text-shadow: 1px 1px 2px #333;"
                  class="card-img-top"
                >
                  <b-carousel-slide v-for="image in rov.images" :key="image.id">
                    <template v-slot:img>
                      <b-img-lazy
                        class="d-block img-fluid w-100"
                        width="1024"
                        height="480"
                        :src="image"
                        alt="V-Drax"
                      ></b-img-lazy>
                    </template>
                  </b-carousel-slide>
                </b-carousel>-->
                <b-img-lazy
                  class="d-block img-fluid w-100"
                  style="background-color: #f2f2f2;"
                  width="1024"
                  height="480"
                  :src="rov.images[0]"
                  :alt="rov.name"
                ></b-img-lazy>
                <b-card-header>
                  <h4 class="mb-0">{{rov.name}}</h4>
                </b-card-header>
                <br />

                <div>
                  <b-badge class="mr-2" variant="warning">Crew available</b-badge>
                  <b-badge
                    v-if="rov.status.id == '1'"
                    class="mr-2"
                    variant="success"
                  >{{rov.status.name}}</b-badge>
                  <b-badge
                    v-if="rov.status.id == '2'"
                    class="mr-2"
                    variant="danger"
                  >{{rov.status.name}}</b-badge>
                  <b-badge variant="warning">up to 4 days</b-badge>
                </div>

                <hr />
                <!-- v-b-toggle="'c-rov-' + rov.id" -->
                <b-button
                  v-if="!rov.noSpecs"
                  @click="scrollDown()"
                  variant="secondary"
                  style=" margin: auto;"
                  v-b-toggle="'c-rov-' + rov.id"
                >Detailed Specifications</b-button>
                <b-button
                  v-if="rov.noSpecs"
                  variant="secondary"
                  style=" margin: auto;"
                  href="/swift-auv"
                  target="_blank"
                >Detailed Specifications</b-button>
                <br />
              </b-card>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <div class="contacts" style="margin:auto;">
        <div class="gmail button">
          <i class="icon">
            <i class="fa fa-google"></i>
          </i>
          <div class="slide-but">
            <p>Reserve by Email</p>
          </div>
          <div style="position:relative !important; top: 20% !important;">
            <a href="mailto:info@vortex-co.com">info@vortex-co.com</a>
          </div>
        </div>
        <div class="google button">
          <i class="icon">
            <i class="fa">&#xf095;</i>
          </i>
          <div class="slide-but">
            <p>Reserve by phone</p>
          </div>
          <div style="position:relative !important; top: 20% !important;">
            <a
              style="position:relative; top: 20%;"
              href="tel:+201116997475"
            >+20&nbsp; 111&nbsp; 6997475</a>
          </div>
        </div>
      </div>
    </div>

    <b-collapse
      accordion="my-accordion"
      v-for="rov in commercialRovs"
      :key="rov.id"
      :id="'c-rov-' + rov.id"
    >
      <b-container>
        <b-row sm v-for="specs in rov.specs" :key="specs.id" class="fade-in">
          <b-col class="vdrax-big-image" sm :order="specs.positionOrder1">
            <b-img-lazy :src="specs.imgSrc" alt="V-Drax" :class="'vdrax-img-' + specs.position"></b-img-lazy>
          </b-col>
          <b-col v-if="!specs.tables" :order="specs.positionOrder2" class="v-drax-specs-content">
            <b-row cols="2">
              <b-col sm="6" v-for="spec in specs.specs" :key="spec.id">
                <b-list-group>
                  <b-list-group-item class="d-flex align-items-center">
                    <b-avatar
                      style="min-width:40px; width: 70px;"
                      square
                      variant="info"
                      :src="spec.logoSrc"
                      class="mr-3"
                    ></b-avatar>
                    <b-badge size="8em" variant="primary" class="mr-2">{{spec.number}}</b-badge>
                    <span class="mr-auto">{{spec.name}}</span>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col v-if="specs.tables" :order="specs.positionOrder2" class="v-drax-specs-content">
            <div v-for="table in specs.tables" :key="table.id">
              <hr />
              <h3 class="table-caption">{{table.caption}}</h3>
              <b-table
                small
                table-variant="secondary"
                outlined
                :items="table.data"
                stacked
                caption-top
              ></b-table>
            </div>
          </b-col>
        </b-row>
        <b-row class="contacts">
          <div style="margin:auto;">
            <div class="gmail button">
              <i class="icon">
                <i class="fa fa-google"></i>
              </i>
              <div class="slide-but">
                <p>Reserve by Email</p>
              </div>
              <div style="position:relative !important; top: 20% !important;">
                <a href="mailto:info@vortex-co.com">info@vortex-co.com</a>
              </div>
            </div>
            <div class="google button">
              <i class="icon">
                <i class="fa">&#xf095;</i>
              </i>
              <div class="slide-but">
                <p>Reserve by phone</p>
              </div>
              <div style="position:relative !important; top: 20% !important;">
                <a
                  style="position:relative; top: 20%;"
                  href="tel:+201116997475"
                >+20&nbsp; 111&nbsp; 6997475</a>
              </div>
            </div>
          </div>
        </b-row>
      </b-container>
      <b-button
        variant="danger"
        pill
        style=" margin: auto;"
        v-b-toggle="'c-rov-' + rov.id"
      >Close Specs</b-button>
    </b-collapse>

    <b-container class="hexa-container">
      <b-row>
        <b-col style="margin:auto;">
          <h3
            style="color: #00264a;"
          >We have a very experienced, motivated and well trained crew available at your service up on request to make your life easier.</h3>
        </b-col>
        <b-col>
          <div class="hexagon hexagon2">
            <div class="hexagon-in1">
              <div class="hexagon-in2"></div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <div id="services_pre_div" style="width:100%; height: 100px;"></div>
    <div class="prod-serv-container eliptical-gray">
      <h2 class="back-text">What we Offer</h2>

      <h3 style="color: #00264a; font-weight: bold;">Our Services</h3>

      <div class="breaker"></div>
      <br />
      <br />
      <br />
      <div class="services-cards-container">
        <div class="services-cards" v-for="service in services" :key="service.id">
          <b-card no-body tag="article" class="mb-2 rov-card">
            <b-img-lazy
              class="d-block img-fluid w-100"
              style="background-color: #f2f2f2;"
              width="1024"
              height="480"
              :src="service.img"
              :alt="service.name"
            ></b-img-lazy>
            <b-card-header style="background-color: white;">
              <h4 class="mb-0">{{service.name}}</h4>
            </b-card-header>
            <br />

            <!-- <div>
              <b-badge class="mr-2" variant="success">Crew Available</b-badge>
              <b-badge class="mr-2" variant="success">Service Available</b-badge>
              <b-badge variant="warning">3 Days Notice</b-badge>
            </div>
            <hr />
            <a style=" margin: auto; font-weight: bold; cursor:pointer;">Show recent Work</a>

            <hr />-->
            <b-button
              @click="migrateItemInfo()"
              style="width :60%; margin: auto;"
              pill
              variant="primary"
            >
              <router-link
                style="color: #fff;"
                :to="{ name: 'ContactUs', params: { type: 2 , name: service.name} }"
              >Ask for quotation</router-link>
            </b-button>

            <br />
          </b-card>
        </div>
      </div>
    </div>
    <br />
    <br />
    <br />
    <br />
  </div>
</template>



<style scoped>
.main_header {
  padding-bottom: 46px;
}

.fade-in {
  margin-bottom: 50px;
  opacity: 0;
  transition: 1.2s all ease-in-out;
  transform: scale(0.8);
  box-sizing: border-box;
  padding: 20px;
}

.header-img-text {
  position: relative;
  top: 300px;
  left: 270px;
  color: #00264a;
  max-width: 700px;
}

.services-cards button {
  background-color: green;
  border-color: green;
}

.services-cards button:hover {
  background-color: rgb(3, 110, 3);
  border-color: rgb(3, 110, 3);
}

.v-drax-specs-content {
  align-self: center;
}

.vdrax-img-left {
  width: 150%;
  margin-left: -150%;
}

.vdrax-img-right {
  width: 150%;
  margin-right: -150%;
}

.vdrax-background {
  background: url(/img/rovs/vdrax/vdrax_2_off.png) no-repeat;
  background-size: cover;
  position: absolute;
  top: 20px;
  opacity: 1;
  width: 1150px;
  height: 850px;
  right: -7%;
  z-index: 2;
  cursor: pointer;
}

.what-we-do {
  width: 40%;
  margin: auto;
  text-align: center;
  font-size: 200%;
  color: #fff;
  font-weight: 900;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  line-height: 40px;
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
}
.fade-in-out {
  opacity: 1;
  animation: fade 1s linear;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.rov-card {
  max-width: 20rem;
  margin: auto;
  z-index: 3;
  border: 20px solid white;
  border-radius: 2%;
}

.services-cards .rov-card {
  border-radius: 20%;
}

.services-cards .w-100 {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.list-group-item {
  border: none;
  transition: 0.3s all ease-in-out;
}

.list-group-item:hover {
  font-weight: bold;
  transform: scale(1.2);
  cursor: pointer;
}

.services-cards-container {
  display: inline-block;
  width: 100%;
  /* height: 400px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap; */
}

.badge-info {
  color: #fff;
  background-color: rgb(0, 0, 0, 0);
}

.badge-primary {
  background-color: yellow;
  color: black;
  font-size: 100%;
}

.b-avatar {
  width: 50%;
  height: 50%;
}

.contacts .button {
  background: #dce0e0;
  position: relative;
  display: inline-block;
  height: 50px;
  margin: 4px;
  overflow: hidden;
  width: 200px;
  border-radius: 3px;
  -o-border-radius: 3px;
  -ms-border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
}
.fb-page,
.fb-page span,
.fb-page span iframe[style] {
  width: 100% !important;
}
.icon {
  display: block;
  float: left;
  position: relative;
  z-index: 3;
  height: 100%;
  width: 38px;
  -moz-border-radius-topleft: 3px;
  -moz-border-radius-topright: 0px;
  -moz-border-radius-bottomright: 0px;
  -moz-border-radius-bottomleft: 3px;
  -webkit-border-radius: 3px 0px 0px 3px;
  border-radius: 3px 0px 0px 3px;
  text-align: center;
}
.icon i {
  color: #fff;
  line-height: 42px;
}
.slide-but {
  z-index: 2;
  display: block;
  margin: 0;
  height: 100%;
  left: 38px;
  position: absolute;
  width: 163px;
  -moz-border-radius-topleft: 0px;
  -moz-border-radius-topright: 3px;
  -moz-border-radius-bottomright: 3px;
  -moz-border-radius-bottomleft: 0px;
  -webkit-border-radius: 0px 3px 3px 0px;
  border-radius: 0px 3px 3px 0px;
}
.slide-but p {
  border-left: 1px solid #fff;
  border-left: 1px solid rgba(255, 255, 255, 0.35);
  color: #fff;
  font-size: 18px;
  left: 0;
  margin: 0;
  position: absolute;
  text-align: center;
  top: 10px;
  width: 100%;
}
.button .slide-but {
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}
.facebook iframe {
  display: block;
  position: absolute;
  right: 23px;
  top: 10px;
  z-index: 1;
}
.twitter iframe {
  width: 90px !important;
  right: 5px;
  top: 10px;
  z-index: 1;
  display: block;
  position: absolute;
}
.google #___follow_0 {
  width: 70px !important;
  top: 10px;
  right: 45px;
  position: absolute;
  display: block;
  z-index: 1;
}
.youtube #___ytsubscribe_0 {
  top: 10px;
  right: 1px;
  position: absolute;
  display: block;
  z-index: 1;
}
.facebook:hover .slide-but {
  left: 220px;
}
.twitter:hover .slide-but {
  top: -40px;
}
.google:hover .slide-but {
  bottom: -50px;
}
.gmail:hover .slide-but {
  bottom: -50px;
}
.youtube:hover .slide-but {
  left: -210px;
}
.linkedin:hover .slide-but {
  left: -210px;
}
.facebook .icon,
.facebook .slide-but {
  background: #305c99;
}
.linkedin .icon,
.linkedin .slide-but {
  background: #006599;
}

.gmail .icon,
.gmail .slide-but {
  background: purple;
}

.google .icon,
.google .slide-but {
  background: #7ea91b;
}

.table-caption {
  color: #9a8c2c;
  caption-side: bottom;
  margin: auto;
  padding-bottom: 10px;
}

.table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
  text-align: left;
}

.video-container {
  background-color: #163e33;
}

.commercial-video-container:before {
  content: "";
  position: absolute;
  bottom: 0px;
  left: 0%;
  margin-left: var(--triangleWidthNeg);
  margin-top: var(--triangleheightNeg);
  width: 0;
  height: 0;
  border-bottom: solid var(--triangleHeight) #fff;
  border-left: solid var(--triangleWidth) transparent;
  border-right: solid var(--triangleWidth) transparent;
  z-index: 2;
}

.commercial-video-container:after {
  content: "";
  position: absolute;
  top: 100%;
  right: 0%;
  margin-right: var(--triangleWidthNeg);
  margin-top: var(--triangleheightNeg);
  width: 0;
  height: 0;
  border-bottom: solid var(--triangleHeight) #fff;
  border-left: solid var(--triangleWidth) transparent;
  border-right: solid var(--triangleWidth) transparent;
  z-index: 2;
}

.commercial-video {
  height: 100vh;
  width: 100%;
  filter: brightness(0.4);
  object-fit: cover;
}

.rovs_cards {
  position: relative;
}

.prod-serv-container {
  background-color: #f2f2f2;
  margin: auto;
}

.categs a {
  color: white;
}

.categs {
  text-align: center;
  margin: 0 auto;
  height: 20px;
  width: 150px;
  color: #fff;
  font-size: 200%;
  font-weight: bolder;
  z-index: 6;
  margin-bottom: 20px;
  cursor: pointer;
  transition: 0.5s;
}

.categs:hover {
  font-size: 220%;
}

.categs-container {
  margin-top: 10%;
}

.services-cards {
  min-width: 300px;
  max-width: 400px;
  padding: 25px 25px 25px 25px;
  display: inline-block;
  overflow: hidden;
  border-radius: 10px;
}

.overlay-background {
  width: 50%;
  right: 0px;
  margin: auto;
  position: relative;
}

.crew-overlay-img {
  width: 100%;
}

.hexagon {
  overflow: hidden;
  visibility: hidden;
  -webkit-transform: rotate(120deg);
  -moz-transform: rotate(120deg);
  -ms-transform: rotate(120deg);
  -o-transform: rotate(120deg);
  transform: rotate(120deg);
  cursor: pointer;
}
.hexagon-in1 {
  overflow: hidden;
  width: 100%;
  height: 100%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}
.hexagon-in2 {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: 50%;
  background-image: url("../../public/img/services/crew_v.jpg");
  background-size: contain;
  visibility: visible;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

.hexagon2 {
  width: 100%;
  height: 600px;

  margin: auto;
}

.bounce {
  text-align: center;
  position: relative;
  top: -20px;
  margin: 0 auto;
  height: 50px;
  width: 150px;
  -webkit-animation: bounce 1.5s infinite;
  font-size: 200%;
  font-weight: bold;
  z-index: 6;
  cursor: pointer;
}

@media (max-width: 1200px) {
  .vdrax-background {
    display: none;
  }
  .header-img-text {
    display: none;
  }
}

@media (max-width: 900px) {
  .categs-container {
    margin-top: -5%;
  }
}

@media (max-width: 770px) {
  .categs-container {
    margin-top: -12%;
  }
  .vdrax-big-image {
    display: none;
  }
  .rov-card {
    margin: auto;
  }
  .b-avatar {
    margin: auto;
  }
  .row-cols-2 > * {
    -ms-flex: 0 0 50%;
    -webkit-box-flex: 0;
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media (max-width: 600px) {
  .categs-container {
    margin-top: -20%;
  }
}

@media (max-width: 500px) {
  .categs-container {
    margin-top: -10%;
  }

  .categs {
    font-size: 130%;
  }

  .hexa-container .col {
    flex-basis: inherit;
  }
  .hexagon2 {
    width: 80%;
    height: 400px;
    margin: auto !important;
  }
}
</style>


<script>
import GearsSep from "./../components/GearsSep.vue";
export default {
  components: {
    GearsSep
  },
  data() {
    return {
      fadeInElements: [],
      lightState: true,
      services: [
        {
          id: 0,
          name: "Tank Inspection",
          img: "img/services/tank-inspection.jpg"
        },
        {
          id: 1,
          name: "Underwater Filming",
          img: "img/services/underwater_filming.jpeg"
        },
        {
          id: 2,
          name: "Sea-bed Survey",
          img: "img/services/seabed-survey.jpg"
        },
        { id: 3, name: "Pipeline inspection", img: "img/services/pipe.png" },
        {
          id: 4,
          name: "Visual Sonar Inspection",
          img: "img/services/visual_sonar_inspection.jpg"
        }
      ],
      commercialRovs: [
        {
          id: 0,
          name: "V-Drax",
          about:
            "V-Drax can be used for offshore services, seabed surveys & underwater exploration.",
          images: [
            "img/rovs/vdrax/vdrax_3d.png",
            "img/rovs/vdrax/1.jpg",
            "img/rovs/vdrax/22.jpg",
            "img/rovs/vdrax/4.jpg",
            "img/rovs/vdrax/3.jpg",
            "img/rovs/vdrax/vdrax-3d.jpg"
          ],
          status: { id: 1, name: "Available for rent" },
          specs: [
            {
              id: 0,
              imgSrc: "img/rovs/vdrax/vdrax_front.png",
              keyImageSrc: "",
              header: "",
              specs: [
                {
                  name: "Thrusters",
                  number: 6,
                  logoSrc: "img/icons/specs/thruster.png"
                },
                {
                  name: "HD Cameras",
                  number: 4,
                  logoSrc: "img/icons/specs/camera.png"
                },
                {
                  name: "Control Panel",
                  logoSrc: "img/icons/specs/cp.png"
                },
                {
                  name: "Portable TMS",
                  logoSrc: "img/icons/specs/tms.png"
                },
                {
                  name: "Acoustic Sonar",
                  logoSrc: "img/icons/specs/sonar.png"
                },
                {
                  name: "Depth hold",
                  logoSrc: "img/icons/specs/dh.png"
                },
                {
                  name: "Auto Heading",
                  logoSrc: "img/icons/specs/ah.png"
                }
              ],
              positionOrder1: "1",
              positionOrder2: "2",
              position: "left"
            },
            {
              id: 1,
              imgSrc: "img/rovs/vdrax/vdrax_top.png",
              keyImageSrc: "",
              header: "",
              specs: [
                {
                  name: "High Reliability",
                  logoSrc: "img/icons/specs/reliability.png"
                },
                {
                  name: "Experienced Crew",
                  logoSrc: "img/icons/specs/crew.png"
                },
                {
                  name: "Easy Maintenance",
                  logoSrc: "img/icons/specs/maintenance.png"
                },
                {
                  name: "Elegant Design",
                  logoSrc: "img/icons/specs/design.png"
                },
                {
                  name: "Dynamic Adj. Buoyancy",
                  logoSrc: "img/icons/specs/buoyancy.png"
                },
                {
                  name: "Manipulators Addition",
                  logoSrc: "img/icons/specs/manipulators.png"
                },
                {
                  name: "Wide Range of View",
                  logoSrc: "img/icons/specs/wide.png"
                },
                {
                  name: "Strong Lighting",
                  logoSrc: "img/icons/specs/light.png"
                }
              ],
              text: "",
              positionOrder1: "2",
              positionOrder2: "1",
              position: "right"
            },
            {
              id: 2,
              imgSrc: "img/rovs/vdrax/vdrax_side.png",
              keyImageSrc: "",
              header: "",
              tables: [
                {
                  caption: "General Specifications",
                  id: 0,
                  data: [
                    {
                      powerRequirements: "220V AC 50 Hz",
                      commProtocols: "RS-485",
                      depthRating: "100 m",
                      payload: "5 Kgf"
                    }
                  ]
                },
                {
                  caption: "Vehicle Dimensions",
                  id: 1,
                  data: [
                    {
                      length: "70 cm",
                      width: "54 cm",
                      height: "48 cm",
                      weight: "60 KG (in air)"
                    }
                  ]
                }
              ],
              positionOrder1: "1",
              positionOrder2: "2",
              position: "left"
            },
            {
              id: 3,
              imgSrc: "img/rovs/vdrax/vdrax_bottom.png",
              table: "Vehicle Dimensions",
              tables: [
                {
                  caption: "Propulsion",
                  id: 0,
                  data: [
                    {
                      maximumSpeed: "1.2 m/s",
                      thruster: "T-200 BlueRobotics thruster",
                      verticalThrust: "2 Thrusters",
                      horizontalThrust: "4 Thrusters"
                    }
                  ]
                },
                {
                  caption: "Lighting",
                  id: 1,
                  data: [
                    {
                      tenLedArrays: "8000 Lumens"
                    }
                  ]
                },
                {
                  caption: "Wirings",
                  id: 2,
                  data: [
                    {
                      tether: "200m Length."
                    }
                  ]
                }
              ],
              text: "",
              positionOrder1: "2",
              positionOrder2: "1",
              position: "right"
            }
          ],
          noSpecs: false
        },
        {
          id: 2,
          name: "Swift AUV",
          about:
            "Swift is an AUV that can fullfill a complete autonomous exploring mission",
          images: ["img/auv/auv/auvv.png"],
          status: { id: 1, name: "Available for rent" },
          noSpecs: true
        },
        {
          id: 1,
          name: "V-Ray",
          about: "V-Ray can be used for  underwater exploration.",
          images: ["img/rovs/vray.png"],
          status: { id: 2, name: "Currently Unavailable" },
          specs: [
            {
              id: 0,
              imgSrc: "img/rovs/vray.jpg",
              keyImageSrc: "",
              header: "",
              specs: [
                {
                  name: "Thrusters",
                  number: 6,
                  logoSrc: "img/icons/specs/thruster.png"
                },
                {
                  name: "HD Cameras",
                  number: 2,
                  logoSrc: "img/icons/specs/camera.png"
                },
                {
                  name: "Control Panel",
                  logoSrc: "img/icons/specs/cp.png"
                },
                {
                  name: "Portable TMS",
                  logoSrc: "img/icons/specs/tms.png"
                },
                {
                  name: "Depth hold",
                  logoSrc: "img/icons/specs/dh.png"
                }
              ],
              positionOrder1: "1",
              positionOrder2: "2",
              position: "left"
            },
            {
              id: 1,
              imgSrc: "img/rovs/vray.jpg",
              keyImageSrc: "",
              header: "",
              specs: [
                {
                  name: "High Reliability",
                  logoSrc: "img/icons/specs/reliability.png"
                },
                {
                  name: "Experienced Crew",
                  logoSrc: "img/icons/specs/crew.png"
                },
                {
                  name: "Easy Maintenance",
                  logoSrc: "img/icons/specs/maintenance.png"
                },
                {
                  name: "Elegant Design",
                  logoSrc: "img/icons/specs/design.png"
                },
                {
                  name: "Wide Range of View",
                  logoSrc: "img/icons/specs/wide.png"
                },
                {
                  name: "Strong Lighting",
                  logoSrc: "img/icons/specs/light.png"
                }
              ],
              text: "",
              positionOrder1: "2",
              positionOrder2: "1",
              position: "right"
            },
            {
              id: 2,
              imgSrc: "img/rovs/vray.jpg",
              keyImageSrc: "",
              header: "",
              tables: [
                {
                  caption: "General Specifications",
                  id: 0,
                  data: [
                    {
                      powerRequirements: "48V DC, 30 A",
                      commProtocols: "RS-485",
                      depthRating: "100 m",
                      payload: "5 Kgf"
                    }
                  ]
                },
                {
                  caption: "Vehicle Dimensions",
                  id: 1,
                  data: [
                    {
                      length: "35 cm",
                      width: "40 cm",
                      height: "32 cm",
                      weight: "15 KG (in air)"
                    }
                  ]
                }
              ],
              positionOrder1: "1",
              positionOrder2: "2",
              position: "left"
            },
            {
              id: 3,
              imgSrc: "img/rovs/vray.jpg",
              table: "Vehicle Dimensions",
              tables: [
                {
                  caption: "Propulsion",
                  id: 0,
                  data: [
                    {
                      maximumSpeed: "2.1 m/s",
                      thruster: "T-100 BlueRobotics thruster",
                      verticalThrust: "2 Thrusters",
                      horizontalThrust: "4 Thrusters"
                    }
                  ]
                },
                {
                  caption: "Lightning",
                  id: 1,
                  data: [
                    {
                      tenLedArrays: "4000 Lumens"
                    }
                  ]
                },
                {
                  caption: "Wirings",
                  id: 2,
                  data: [
                    {
                      tether: "50m Length."
                    }
                  ]
                }
              ],
              text: "",
              positionOrder1: "2",
              positionOrder2: "1",
              position: "right"
            }
          ],
          noSpecs: false
        }
      ],

      small_about_vdrax:
        "V-drax is our first offshore ROV that is designed to implement inspection missions with high efficiency and till 200 meter depth."
    };
  },
  methods: {
    handleScroll(evt) {
      for (var i = 0; i < this.fadeInElements.length; i++) {
        var elem = this.fadeInElements[i];
        if (this.isElemVisible(elem)) {
          elem.style.opacity = "1";
          elem.style.transform = "scale(1)";
          //this.fadeInElements.splice(i, 1); // only allow it to run once
        } else {
          elem.style.opacity = "0";
          //elem.style.transform = "scale(0)";
        }
      }
    },
    migrateItemInfo() {
      this.setActive(7);
      document.documentElement.style.scrollBehavior = "auto";
      window.scrollTo(0, 0);
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = "smooth";
        document.getElementById("contact-form").scrollIntoView(false);
      }, 1000);
    },
    setActive(id) {
      document.getElementById("nav" + id).style.borderTop = "5px solid #00264A";
      var i;
      for (i = 2; i < 8; i++) {
        if ("nav" + i === "nav" + id) {
          continue;
        } else {
          document.getElementById("nav" + i).style.borderTop =
            "5px solid #dddddd";
        }
      }
    },
    isElemVisible(el) {
      var rect = el.getBoundingClientRect();
      var elemTop = rect.top + 150; // 200 = buffer
      var elemBottom = rect.bottom;
      return elemTop < window.innerHeight && elemBottom >= 0;
    },
    scrollDown() {
      document.documentElement.style.scrollBehavior = "smooth";
      setTimeout(() => window.scrollTo(0, window.scrollY + 600), 300);
    },
    doFlashing(count) {
      for (var i = 0; i < count * 2; i++) {
        setTimeout(
          () =>
            (document.getElementById("vdrax-background").style.backgroundImage =
              "url('img/rovs/vdrax/vdrax_2.png')"),
          500 + i * 200
        );
        setTimeout(
          () =>
            (document.getElementById("vdrax-background").style.backgroundImage =
              "url('img/rovs/vdrax/vdrax_2_off.png')"),
          500 + ++i * 200
        );
      }
      setTimeout(
        () =>
          (document.getElementById("vdrax-background").style.backgroundImage =
            "url('img/rovs/vdrax/vdrax_2.png')"),
        500 + count * 2 * 200
      );
    },
    toggleLight() {
      if (this.lightState) {
        document.getElementById("vdrax-background").style.backgroundImage =
          "url('img/rovs/vdrax/vdrax_2_off2.png')";
        this.lightState = false;
      } else {
        document.getElementById("vdrax-background").style.backgroundImage =
          "url('img/rovs/vdrax/vdrax_2.png')";
        this.lightState = true;
      }
    },
    scrollToDiv(div_id) {
      var elmnt = document.getElementById(div_id);
      elmnt.scrollIntoView();
    }
  },
  mounted() {
    var tabs = document.getElementById("right_nav").querySelectorAll("a");
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].style.color = "white";
    }
    document
      .getElementById("vortexNameImage")
      .setAttribute("src", "img/logos/vortex_name2.png");
    window.scrollTo(0, 10);
    this.fadeInElements = Array.from(
      document.getElementsByClassName("fade-in")
    );
    document.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  unmounted() {
    document.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
